/**
 * The tab bar on a phone: Home, Apps, Search, Create, and the current app's
 * pages — within a thumb's reach, since the top bar is not.
 *
 * Hidden above 640px by CSS. Nothing here is phone-only: each button opens
 * the same launcher, command center, create menu or app navigation the
 * desktop reaches from the top bar.
 */
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link, useOrgBase } from '../routes/orgNavigation.jsx';
import { Icon } from '../components/Icon.jsx';
import { Modal } from '../components/Modal.jsx';
import { QuickCreateMenu } from './QuickCreate.jsx';
import { appName } from './apps.js';

export function MobileNav({ currentApp, createActions, onOpenLauncher, onOpenCommand, onOpenNav }) {
  const { t } = useTranslation('navigation');
  const [creating, setCreating] = useState(false);
  const location = useLocation();
  const base = useOrgBase();
  const atHome = location.pathname === base || location.pathname === `${base}/`;

  return (
    <>
      <nav className="mobilenav" aria-label={t('mobileNav.label')}>
        <Link to="/" className={`mobilenav-item ${atHome ? 'is-active' : ''}`} aria-current={atHome ? 'page' : undefined}>
          <Icon name="home" size={20} />
          <span>{t('items.home.label')}</span>
        </Link>
        <button type="button" className="mobilenav-item" onClick={onOpenLauncher}>
          <Icon name="apps" size={20} />
          <span>{t('mobileNav.apps')}</span>
        </button>
        <button type="button" className="mobilenav-item" onClick={onOpenCommand}>
          <Icon name="search" size={20} />
          <span>{t('common:actions.search')}</span>
        </button>
        {createActions.length > 0 && (
          <button type="button" className="mobilenav-item" onClick={() => setCreating(true)}>
            <Icon name="plus" size={20} />
            <span>{t('common:actions.create')}</span>
          </button>
        )}
        <button
          type="button"
          className="mobilenav-item"
          onClick={onOpenNav}
          disabled={!currentApp}
          aria-label={currentApp ? t('mobileNav.appPages', { app: appName(currentApp, t, { bilingual: false }) }) : t('mobileNav.noAppPages')}
        >
          <Icon name="menu" size={20} />
          <span>{currentApp ? t('mobileNav.pages') : t('mobileNav.menu')}</span>
        </button>
      </nav>

      {creating && (
        <Modal open onClose={() => setCreating(false)} title={t('common:actions.create')}>
          <div
            onClick={(event) => {
              if (event.target.closest('a')) setCreating(false);
            }}
            role="presentation"
          >
            <QuickCreateMenu actions={createActions} currentKey={currentApp?.key} />
          </div>
        </Modal>
      )}
    </>
  );
}
